import React, {
    useState,
    useEffect,
    useRef,
    useContext,
    useCallback
  } from 'react'
  import Table from '../../../dpe-usco/components/Table/Table'
  import { NestedCheckBox, Modal } from 'syngenta-react-components'
  import clear from '../../../assets/icons/clear.svg'
  import info from '../../../assets/icons/info.svg'
  import { Button } from 'syngenta-react-components'
  import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
  import { GlobalContext } from '../../../services/context'
  import { getFieldBoundaryCenter } from '../../../services/utils'
  import error_outline from '../../../assets/icons/error_outline.svg'
  import { postAssignFields, getHighestRole } from '../../../services/apiHelper'
  import greenCheck from '../../../assets/icons/circle_check_green.svg'
  
  
  const headerContent = value => {
    return (
      <div key={value} className="cell df aic">
        <span className="cell">{value}</span>
      </div>
    )
  }
  
  const AssignEnogenFieldsView = ({
    showAssignEnogenFields,
    setShowAssignEnogenFields,
    farmArray,
    fieldArray,
    status,
    contractYear,
    _defaultFields,
    getStewardshipFieldsCall,
    contract_id,
    sap_id,
    plantingData,
    growerData
  }) => {
    const { trackEvent } = useContext(GlobalContext)
    const [checkboxData, setCheckboxData] = useState({})
    const [rowInputs, setRowInputs] = useState({})
    const [tableData, setTableData] = useState([])
    const [stateFarmArray, setStateFarmArray] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [tablePrompt, setTablePrompt] = useState()
    const [totalAcresValue, setTotalAcresValue] = useState()
    const [isSaveSave, setIsSaveSave]  = useState(false)
    const [fieldError, setFieldError] = useState(false)
    const [fieldValue, setFieldValue] = useState([])
    const [confirmStatus, setConfirmStatus] = useState('INIT')
    const [userInfo, setUserInfo] = useState({})

    useEffect(() => {
      getHighestRole().then(highestRoleData => {
        setUserInfo({
          'user_id': highestRoleData.user_id,
          'user_name': highestRoleData.first+ ' ' + highestRoleData.last,
          'user_email': highestRoleData.email,
          'system_name': 'GrowMore360'
        })
      })
    }, [])
  
    useEffect(() => {
      if(!showAssignEnogenFields) {
        setFieldError(false)
      }
    },[showAssignEnogenFields])
  
    useEffect(() => {   
      if (status !== 'WAITING') {
        setTablePrompt('selected grower has no fields')
      }
    }, [status])
  
    const handleSubmit = () => {
      const fieldOutput = []
      for (let field in rowInputs) {
        let fieldCenter = getFieldBoundaryCenter(rowInputs[field].field_boundary)
        fieldCenter = fieldCenter ? fieldCenter : {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [
              -0.0,
              -0.0
            ]
          }
        }
        const newField = {
          field_name: rowInputs[field].field_name,
          field_id: rowInputs[field].field_id,
          planting_rate: rowInputs[field]?.planting_rate?.toString(),
          average_yield: rowInputs[field]?.aph?.toString(),
          border_rows: rowInputs[field].border_rows,
          acres: rowInputs[field].field_acres.toString(),
          crop_year: contractYear?.toString(),
          latitude: fieldCenter.geometry.coordinates[1].toString(),
          longitude: fieldCenter.geometry.coordinates[0].toString(),
          is_total: false
        }
        const index = tableData.findIndex(data => data.field_id === rowInputs[field].field_id)
        if(index !== -1){
          fieldOutput.push(newField)
        }
      }
  
      if (fieldOutput.length > 0) {
        setFieldValue(fieldOutput)
        setIsSaveSave(true)
      } else {
        setFieldValue([])
        setFieldError(true)
      }
    }
  
const handleSubmitConfirm = async () => {
  setConfirmStatus('LOADING')
  
  const postData = {
    'fields': fieldValue,
    'stewardship_history': userInfo
  }

  try {
    let response = await postAssignFields(contract_id, postData, sap_id, plantingData)

    if (response?.status !== 200) {
      getStewardshipFieldsCall()
      setIsSaveSave(false)
      setShowAssignEnogenFields(false)
      setFieldError(false)
      setConfirmStatus('ERROR')
      return
    }

    getStewardshipFieldsCall()
    setIsSaveSave(false)
    setShowAssignEnogenFields(false)
    setFieldError(false)
    setConfirmStatus('SUCCESS')
    
  } catch (error) {
    console.error('Error processing fields:', error)
    getStewardshipFieldsCall()
    setIsSaveSave(false)
    setShowAssignEnogenFields(false)
    setFieldError(false)
    setConfirmStatus('ERROR')
  }
}

  
    const renderCheckBox = () => {
      const privFunc = (newList, i) => {
        let newObj = {}
        newList.forEach(check => {
          newObj[check.id] = { index: i, value: check.isChecked }
          if (!check.isChecked) {
            setRowInputs(prev => {
              return {
                ...prev,
                [check.id]: {
                  ...prev[check.id],
                  aph: 0,
                  planting_rate: 0,
                  border_rows: false
                }
              }
            })
          }
        })
        setCheckboxData(prev => {
          return { ...prev, ...newObj }
        })
        setStateFarmArray(prev => {
          const newArr = prev.map(obj => ({ ...obj }))
          newArr[i].data = newList
          return newArr
        })
      }
  
      if (stateFarmArray.length) {
        return stateFarmArray.map((data, i) => {
          return (
            <NestedCheckBox
              key={i}
              dataArray={data?.data}
              title={data?.title}
              updateList={newList => privFunc(newList, i)}
            />
          )
        })
      }
      return null
    }
  
    const checkboxTracker = useCallback(
      (quantity, status, value) => {
        const eventType = `${quantity}_${status}`
        let eventProperties = {}
        if (quantity === 'farm') {
          eventProperties.farmId = farmArray[value]?.farm_id
        } else {
          eventProperties.fieldId = value
        }
        trackEvent(eventType, eventProperties)
      },
      [farmArray, trackEvent]
    )
  
    const prevCheckboxData = useRef({})
    useEffect(() => {
      const farms = {}
      const prevFarms = {}
      let changedField
      for (let fieldId in prevCheckboxData.current) {
        const field = prevCheckboxData.current[fieldId]
        if (prevFarms[field.index]) {
          prevFarms[field.index] = prevFarms[field.index] + (field.value ? 1 : 0)
        } else {
          prevFarms[field.index] = field.value ? 1 : 0
        }
      }
      for (let fieldId in checkboxData) {
        const field = checkboxData[fieldId]
        if (!prevCheckboxData.current[fieldId]) {
          if (field.value) {
            changedField = fieldId
            if (field.index) {
              if (farms[field.index]) {
                farms[field.index] = farms[field.index] + 1
              } else {
                farms[field.index] = 1
              }
            }
          }
        } else {
          if (prevCheckboxData.current[fieldId].value !== field.value) {
            changedField = fieldId
          }
          if (farms[field.index]) {
            farms[field.index] = farms[field.index] + (field.value ? 1 : 0)
          } else {
            farms[field.index] = field.value ? 1 : 0
          }
        }
      }
      for (let index in farms) {
        if (prevFarms[index] !== undefined) {
          if (prevFarms[index] - farms[index] === 1) {
            checkboxTracker('field', 'unchecked', changedField)
          } else if (prevFarms[index] - farms[index] > 1) {
            checkboxTracker('farm', 'unchecked', index)
          } else if (prevFarms[index] - farms[index] < -1) {
            checkboxTracker('farm', 'checked', index)
          } else if (prevFarms[index] - farms[index] === -1) {
            checkboxTracker('field', 'checked', changedField)
          }
        } else {
          if (farms[index] > 1) {
            checkboxTracker('farm', 'checked', index)
          } else {
            checkboxTracker('field', 'checked', changedField)
          }
        }
      }
  
      prevCheckboxData.current = checkboxData
    }, [checkboxData, checkboxTracker])
  
    const updateCheckboxAndInputs = field => { 
      let newObj = {}
      newObj[field.field_id] = { ...newObj[field.field_id], value: false }
      setRowInputs(prev => {
        return {
          ...prev,
          [field.field_id]: {
            ...prev[field.field_id],
            planting_rate: 0,
            aph: 0,
            border_rows: false
          }
        }
      })
  
      setCheckboxData(prev => {
        return { ...prev, ...newObj }
      })
      setStateFarmArray(farmArray => {
        const newFarmArr = farmArray.map(farm => {
          if (farm.farm_id === field.farm_id) {
            const newFieldArr = farm.data.map(dataField => {
              if (dataField.id === field.field_id) {
                return { ...dataField, isChecked: false }
              }
              return dataField
            })
            return { ...farm, data: newFieldArr }
          }
          return farm
        })
        return newFarmArr
      })
    }
  
    useEffect(()=>{
      let yieldValue = 0
      let totalAcresValue = 0
      for (let field in rowInputs) { 
        const index = tableData.findIndex(data => data.field_id === field)
        if(index !== -1){
          yieldValue += Number(rowInputs[field].aph) * Number(rowInputs[field].field_acres)
          totalAcresValue += Number(rowInputs[field].field_acres)
        }
      }
      yieldValue = Math.round(yieldValue)
      if(isNaN(yieldValue)){
        yieldValue = 0
      } 
      setTotalAcresValue(totalAcresValue)
    }, [tableData, rowInputs])
  
    const fieldsStructure = {
      headers: [
        {
          value: 'Name',
          format() {
            return headerContent(this.value)
          }
        },
        {
          value: 'Acres',
          format() {
            return headerContent(this.value)
          }
        },
        {
          value: 'Border rows?',
          format() {
            return (
              <button
                key={'border_row'}
                className="bgc-t bdnone curp fz15 fw700 cell df aic jcc"
                onClick={() => setShowModal(true)}
              >
                <div>
                  <span className="df fxww w50%">Border rows?</span>
                </div>
                <img className="curp" src={info} alt="more info" />
              </button>
            )
          }
        },
        {
          value: '',
          format() {
            return <div key="blank" className="w50" />
          }
        }
      ],
      dataKeys: [
        'field_name',
        'field_acres',
        'border_rows',
        'button'
      ],
      customMemoAreEqual: (prev, current) => {
        if (prev.field_id === current.field_id) {
          return true
        }
        return false
      },
      rowFormat: {
        border_rows: {
          customStyle: 'df jcc aic',
          allContent: true,
          format: field => {
            return (
              <input
                type="checkbox"
                className="wa"
                name={`${field.field_id}_border_rows`}
                value={rowInputs[field.field_id]?.border_rows}
                onChange={e => updateField(e, field.field_id, 'border_rows')}
              />
            )
          }
        },
        button: {
          customStyle: 'w50',
          overwriteStyles: true,
          allContent: true,
          format: field => {
            return (
              <button
                className="bdnone bgc-white"
                onClick={() => updateCheckboxAndInputs(field)}
              >
                <img src={clear} alt="remove row" />
              </button>
            )
          }
        }
      }
    }
    const updateField = (e, field_id, key) => {
      const temp = { ...e }
      if (key === 'border_rows') {
        setRowInputs(prev => {
          return {
            ...prev,
            [field_id]: { ...prev[field_id], border_rows: temp.target.checked }
          }
        })
      }
    }
  
    useEffect(() => {
      if (_defaultFields?.size) {
        const newObj = {}
        const newCheckboxObj = {}
        const newObjArray = []
        _defaultFields.forEach(field => {
          const newFieldObj = {
            field_name: field.field_name,
            field_id: field.field_id,
            field_acres: field.acres,
            field_boundary: field.field_boundary,
            aph: field.average_yield,
            planting_rate: field.planting_rate,
            border_rows: field.border_rows
          }
  
          newObj[field.field_id] = newFieldObj
          newCheckboxObj[field.field_id] = {
            ...newCheckboxObj[field.field_id],
            value: true
          }
          newObjArray.push(newFieldObj)
        })
        setRowInputs(newObj)
        setCheckboxData(newCheckboxObj)
      }
    }, [_defaultFields])
  
    useEffect(() => {
      const newestTableData = []
      if (fieldArray.length) {
        fieldArray.forEach(field => {
          if (checkboxData[field.field_id]?.value) {
            const newField = { ...field }
            newestTableData.push(newField)
          }
        })
        if ( tableData.length !== newestTableData.length ) {
          setTableData(newestTableData)
        }
      }
    }, [checkboxData, fieldArray, tableData])
  
    useEffect(() => {
      const newObj = {}
      if (fieldArray.length) {
        if (_defaultFields?.size) {
          fieldArray.forEach(field => {
            let aph = 0
            let planting_rate = 0
            if (_defaultFields.has(field.field_id)) {
              const currentField = _defaultFields.get(field.field_id)
              aph = currentField.average_yield
              planting_rate = currentField.planting_rate
            }
            newObj[field.field_id] = {
              field_name: field.field_name,
              field_id: field.field_id,
              field_acres: field.field_acres,
              field_boundary: field.field_boundary,
              aph,
              planting_rate,
              border_rows: false
            }
          })
        } else {
          fieldArray.forEach(field => {
            newObj[field.field_id] = {
              field_name: field.field_name,
              field_id: field.field_id,
              field_acres: field.field_acres,
              field_boundary: field.field_boundary,
              aph: 0,
              planting_rate: 0,
              border_rows: false
            }
          })
        }
        setRowInputs(newObj)
      }
    }, [_defaultFields, fieldArray])
  
    useEffect(() => {
      let mergedArray = farmArray.map(farm => {
        const newFarm = { ...farm }
        newFarm.data = newFarm.data.map(field => {
          return { ...field }
        })
        return newFarm
      })
      if (farmArray.length && _defaultFields?.size) {
        mergedArray = mergedArray.map(farm => {
          const newData = farm.data.map(field => {
            let found = { ...field }
            if (_defaultFields.has(field.id)) {
              found = { ...field, isChecked: true }
            }
            return found
          })
          return { ...farm, data: newData }
        })
      }
      setStateFarmArray(mergedArray)
    }, [_defaultFields, farmArray, setStateFarmArray])
  
    const showYieldValue = (
      <div className="df mt10 mb10">
        <div className="df flx2"></div>
        <div className="df flx1">
          <span className="fwb fz16">Total Acres</span>
        </div>
        <div className="df flx1">
          <span className="fwb fz16">{parseFloat(totalAcresValue).toFixed(2)}</span>
        </div>
      </div>
    )
  
  
    const renderContent = statusArg => {
      let content
      switch (statusArg) {
        case 'INIT':
          content = (<>
            <div>
              <div className="pl25 pr16">
                <div>Are you sure you want to Update this contract?</div>
              </div>
          
  
              <hr className="mt20 mb10 bdnone bt1-s-lightgray" />
              <div className="df jcfe">
                <Button text='No' customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4' clickHandler={() => setShowAssignEnogenFields(false)} />
                <Button type='success' text='Yes' clickHandler={handleSubmitConfirm} customClassName=' mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
              </div>
            </div>
          </>)
          break
        case 'LOADING':
          content = <TableStatus status='LOADING'></TableStatus>
          break
        case 'SUCCESS': {
          content = (<div className='df jcc p15 pl25'>
            <img src={greenCheck} alt='check mark'></img>
            <div className='ml10'>Contract Updated Successfully!</div>
          </div>)
          break
        }
        case 'ERROR': {
          content = <div className='m55 pl25 c-red'>Error in updating contract.</div>
          break
        }
        default:
          break
      }
      return content
    }
   
    return (
  
      <div className="modalContainer" style={{ display: showAssignEnogenFields ? 'block' : 'none' }}>
        <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
          <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
     
            <div className="df jcsb">
              <p className="fz16 ml16 fw600">Add Enogen Fields</p>
              <button className='bdnone m0 bgc-t' onClick={() => setShowAssignEnogenFields(false)}>
                <img src={clear} alt='cancel button' />
              </button>
            </div>
            <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
        
            {!isSaveSave?
              <div>
                <div className="pl16 pr16">
                  {fieldError &&
              <div className="c-red tal fz16 df">
                <img src={error_outline}
                  alt='error icon'>
                </img>
                
                <div className='ml10'>Please select and fill out at least one field</div>
              </div>
                  }
                  <div className="df mt25 mb20">
                    <div className="df pt10 pr20 pl20 fxdrc mr25 mah600 bd1-s-lightgray bdrs-4 miw200 oys">
                      {status !== 'LOADING' && renderCheckBox()}
                    </div>
                
                    <div className="flx1 mah700" data-testid="tableInFieldWidget">
                      <Table
                        data={tableData}
                        structure={fieldsStructure}
                        statusComponent={
                          status ? (
                            <TableStatus
                              status={status === 'WAITING' ? 'EMPTY' : status}
                              prompt={tablePrompt}
                            />
                          ) : null
                        }
                        showYieldValue={showYieldValue}
                      />
                    </div>
                
                  </div>
                </div>
          
  
                <hr className="mt20 mb16 bdnone bt1-s-lightgray" />
                <div className="df jcfe">
                  <Button text='Cancel' customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4' clickHandler={() => setShowAssignEnogenFields(false)} />
                  <Button type='success' text='Assign Fields' clickHandler={handleSubmit} disabled={status === 'LOADING'} customClassName=' mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
                </div>
              </div>
  
              :
              <>
                {renderContent(confirmStatus)}
                <div className='tac'>
                  {(confirmStatus === 'SUCCESS' || confirmStatus === 'ERROR') && <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={() => setShowAssignEnogenFields(false)} />}
                </div>
              </>
            }
  
          </div>
        </div>
  
        <Modal
          autoHeight
          show={showModal}
          handleClose={() => setShowModal(false)}
        >
          <div className="w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4">
            <div className="df jcsb">
              <p className="fz16 ml16 fw600">Should you include border rows?</p>
              <button
                className="bdnone m0 bgc-t"
                onClick={() => setShowModal(false)}
              >
                <img src={clear} alt="close modal" />
              </button>
            </div>
            <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
  
            <div className="df aic w100%">
              <img src={info} alt="more info" className="w10% ml20" />
              <p className="w80% mr20">
                Enogen fields require 30’ of spatial isolation from any adjacent
                annual crop. If no natural isolation exists, a 30’ width of border
                rows consisting of a non-Enogen corn hybrid must be planted next
                to that adjacent crop (only), and be considered part of the Enogen
                field. Please indicate whether each individual field require at
                least some length of border rows.
              </p>
            </div>
            <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
            <div className="w100% tar">
              <Button
                customClassName="mr10"
                styleType="success"
                text="Close"
                clickHandler={() => setShowModal(false)}
              />
            </div>
          </div>
        </Modal>
  
      </div>
    )
  }
  export default AssignEnogenFieldsView